// import utils
import { t } from 'i18next';
import { nlNL } from '@mui/x-date-pickers/locales';

export const customDatePickerLocaleText = {
  ...nlNL.components.MuiLocalizationProvider.defaultProps.localeText,
  todayButtonLabel: t('today')
};
